import { VisitTemplate } from '@dreryk/egabinet-visit-frontend-api';

import { PromiseVoidFunction } from '@dreryk/react-common';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { visitTemplatesTranslationKeys } from '../translations';

import { VisitTemplateForm, VisitTemplateFormChildrenRenderProps } from './form/VisitTemplateForm';
import { VisitTemplateReadOnly } from './readOnly/VisitTemplateReadOnly';
import { VisitTemplatesLoader } from './VisitTemplates.loader';
import { VisitTemplateInsert, VisitTemplatesInitialEditTemplateDetails } from './VisitTemplates.types';
import { VisitTemplatesList } from './VisitTemplatesList';
import { VisitTemplatesSendTemplateButton } from './VisitTemplatesSendTemplateButton';

type VisitTemplatesEditSlotRenderProps = VisitTemplateFormChildrenRenderProps & {
   onTemplateSaveSuccess: PromiseVoidFunction;
   ready: boolean;
};

type VisitTemplatesProps = {
   readonly initialEditItem: VisitTemplatesInitialEditTemplateDetails;
   readonly onInsert?: VisitTemplateInsert;
   readonly readOnlySlot?: JSX.Element;
   readonly editSlot: (renderProps: VisitTemplatesEditSlotRenderProps) => JSX.Element;
   readonly children?: JSX.Element;
};

// eslint-disable-next-line max-lines-per-function
export const VisitTemplates = (props: VisitTemplatesProps): JSX.Element => {
   return (
      <FormsTemplates>
         <VisitTemplatesLoader>
            {({ templates, loading, refetch }) => (
               <FormsTemplates.State<VisitTemplate> templates={templates ?? []} initialEditItem={props.initialEditItem}>
                  <>
                     {!templates || loading ? null : <VisitTemplatesList onTemplateRemoved={refetch} />}

                     <FormsTemplates.ReadOnlySection<VisitTemplate>>
                        {({ activeItem }) => (
                           <>
                              <VisitTemplateReadOnly onInsert={props.onInsert} item={activeItem} />
                              {props.readOnlySlot}
                           </>
                        )}
                     </FormsTemplates.ReadOnlySection>
                     <FormsTemplates.FormSection<VisitTemplate>>
                        {({ activeItem, disableSwitching, enableSwitching, setActiveItemName, templatesApiRef }) => (
                           <VisitTemplateForm
                              template={activeItem}
                              onDirty={disableSwitching}
                              onPristine={enableSwitching}
                              templatesApiRef={templatesApiRef}
                              onTemplateNameChange={setActiveItemName}
                           >
                              {(formSectionProps) =>
                                 props.editSlot({ ...formSectionProps, ready: loading, onTemplateSaveSuccess: refetch })
                              }
                           </VisitTemplateForm>
                        )}
                     </FormsTemplates.FormSection>

                     {props.children}

                     {Boolean(templates?.length) || loading ? null : (
                        <>
                           <FormsTemplates.EmptyStatePlaceholder
                              subheading={visitTemplatesTranslationKeys.noAvailableVisitTemplatesYet}
                           />
                        </>
                     )}
                  </>
               </FormsTemplates.State>
            )}
         </VisitTemplatesLoader>
      </FormsTemplates>
   );
};

VisitTemplates.SendTemplateButton = VisitTemplatesSendTemplateButton;
